import { atom } from "jotai";

export const loadingState = atom(false);